import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import "./stylesheets/fonts.css";
import ErrorBoundary from "./ErrorBoundary";
import "semantic-ui-css/semantic.min.css";
import "./Courses/stylesheets/landingPageStyles.css";
import { configureStore } from '@reduxjs/toolkit'
import LoginModalReducer from './Layout/Header/LoginModalSlice'
import thunkMiddleware from 'redux-thunk'
import { Provider } from 'react-redux'
import {  BrowserRouter as Router } from 'react-router-dom'

const store = configureStore({
  reducer: LoginModalReducer,
  middleware: [thunkMiddleware]
})

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
